import { render, staticRenderFns } from "./GroupMemberDialog.vue?vue&type=template&id=bc8229ca&scoped=true"
import script from "./GroupMemberDialog.vue?vue&type=script&lang=js"
export * from "./GroupMemberDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberDialog.vue?vue&type=style&index=0&id=bc8229ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../lianqiao-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8229ca",
  null
  
)

export default component.exports